import React, { useEffect, useState } from "react";
import LoginForm from "../Components/LoginForm";
import * as httpClient from "../../util/httpClient";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { useLocation } from "react-router-dom";
import "../Assets/css/landing-pages-main.scss";
import { Notification } from "../../components/common/Notification";

const MyDish = (props: any) => {
    const location = useLocation();
    const [renderComp, setRenderComp] = useState("");
    const [renderStyle, setRederStyle] = useState("");
    const [isResponseRendered, setResponseRender] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [renderLeftContent, setRenderLeftContent] = useState("");
    const [renderTitle, setRederTitle] = useState("");
    const [renderLink, setRederLink] = useState("");
    const [showNotification, setShowNotification] = useState(false);

    const query = new URLSearchParams(location.search);
    const RetailerCode: any = query.get("RetailerCode") || query.get("RETAILERCODE");

    const partnerId = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration.partnerConfig.partnerId) {
            return state.configurationState.configuration.partnerConfig.partnerId;
        }
    });
    const getHomePageHTMLSerData = () => {
        setIsLoading(true);
        const requestBody = {
            PartnerID: partnerId,
        };
        httpClient
            .sendRequest("POST", "api/LandingPage/GetLandingPageSerData", requestBody)
            .then((data) => {
                if (data?.key! == null || !data["HasError"]) {
                    setRederStyle(data.homePageStyle);
                    setRenderComp(data.homePageHTML);
                    setRederLink(data.redirectLink);
                    setTimeout(() => {
                        setResponseRender(true);
                    }, 2000);
                }
            })
            .catch(function (error) {
                setIsLoading(true);
                setShowNotification(true);
            });
    };

    useEffect(() => {
        if (partnerId) {
            getHomePageHTMLSerData();
        }
    }, [partnerId]);

    useEffect(() => {
        if (showNotification) {
            Notification({
                type: "error",
                title: "An Error has Occurred",
                message: "Something went wrong, Please try again.",
                duration: 10,
            });
            setShowNotification(false);
        }
    }, [showNotification]);

    useEffect(() => {
        if (isResponseRendered) {
            const domParser = new DOMParser();
            const parsedDoc = domParser.parseFromString(renderComp, "text/html");
            const leftContent = parsedDoc.querySelector("div.home-main-message");
            if (leftContent) {
                setRenderLeftContent(leftContent?.innerHTML);
            }
            const titleDiv = parsedDoc.querySelector("div.home-login-container");
            if (titleDiv) {
                const titleElement = titleDiv.querySelector("h1");
                if (titleElement) {
                    setRederTitle(titleElement.innerText);
                }
            }
            const redirectLinkDiv = parsedDoc.querySelector("div.home-create-account");
            if (redirectLinkDiv) {
                const anchorElement = redirectLinkDiv.querySelector("a");
                if (anchorElement) {
                    if (RetailerCode && renderLink && renderLink.includes("@RetailerCode")) {
                        const retailerRedirectURL = renderLink.replace("@RetailerCode", RetailerCode);
                        anchorElement.setAttribute("href", retailerRedirectURL);
                    } else {
                        anchorElement.setAttribute("href", renderLink);
                    }
                }
                setRederLink(redirectLinkDiv.innerHTML);
            }
            setIsLoading(false);
        }
    }, [isResponseRendered]);

    if (isLoading) {
        return (
            <div className="col-xs">
                <div className={`loading`}></div>
            </div>
        );
    } else {
        return (
            <React.Fragment>
                <style dangerouslySetInnerHTML={{ __html: renderStyle }}></style>

                <div id="landing-page-container" className="landing-pages-TMPL9">
                    <div className="home-page">
                        <div className="home-main-message">
                            <div dangerouslySetInnerHTML={{ __html: renderLeftContent }}></div>
                        </div>
                        <div className="home-login-container">
                            <h1>{renderTitle}</h1>
                            <div className="home-login-form">
                                <LoginForm />
                            </div>
                            <div className="home-create-account">
                                <div dangerouslySetInnerHTML={{ __html: renderLink }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
};
export default MyDish;
